<script>
// import { store } from "./_juicebox-store.js";
import moment from "moment";
import { mapActions } from "vuex";

export default {
	name: "events-calendar",
	components: {},
	data() {
		return {
			today: moment(),
			dateContext: moment.unix(this.$store.state.currentDate[0]),
			days: ["S", "M", "T", "W", "T", "F", "S"],
			data: this.$store.state
		};
	},
	computed: {
		year: function() {
			return moment.unix(this.data.currentDate[0]).format("Y");
		},
		month: function() {
			return moment.unix(this.data.currentDate[0]).format("MMMM");
		},
		daysInMonth: function() {
			return moment.unix(this.data.currentDate[0]).daysInMonth();
		},
		currentDate: function() {
			return moment.unix(this.data.currentDate[0]).get("date");
		},
		firstDaysOfMonth: function() {
			var lastDay = moment
				.unix(this.data.currentDate[0])
				.subtract(1, "month")
				.endOf("month");

			var remainingDays = lastDay.isoWeekday();

			var i;
			var lastDays = [];
			for (i = 0; i < remainingDays; i++) {
				lastDays.push(
					moment(lastDay)
						.subtract(i, "days")
						.format("D")
				);
			}

			lastDays.reverse();

			return lastDays;
		},
		lastDaysOfMonth: function() {
			var firstDay = moment
				.unix(this.data.currentDate[0])
				.add(1, "month")
				.startOf("month");

			var nextDays = 8 - firstDay.isoWeekday();

			var i;
			var firstDays = [];
			for (i = 0; i < nextDays; i++) {
				firstDays.push(
					moment(firstDay)
						.add(i, "days")
						.format("D")
				);
			}
			return firstDays;
		},
		initialDate: function() {
			return this.today.get("date");
		},
		initialMonth: function() {
			return this.today.format("MMMM");
		},
		initialYear: function() {
			return this.today.format("Y");
		}
	},
	methods: {
		...mapActions(["setCurrentDate", "loadEvents", "setFilteredEvents"]),
		subtractMonth: function() {
			var dates = {};
			dates.start = moment
				.unix(this.data.currentDate[0])
				.subtract(1, "month")
				.startOf("month")
				.unix();
			// .format("YYYYMMDD");
			dates.end = moment
				.unix(this.data.currentDate[0])
				.subtract(1, "month")
				.endOf("month")
				.unix();

			this.setFilteredEvents([]);
			this.loadEvents(dates);
			// Subtract one day, week or month to both dates if it's a range or not.
			this.setCurrentDate({
				date: [dates.start, dates.end],
				span: "month"
			});
		},
		addMonth: function() {
			var dates = {};
			dates.start = moment
				.unix(this.data.currentDate[0])
				.add(1, "month")
				.startOf("month")
				.unix();

			dates.end = moment
				.unix(this.data.currentDate[0])
				.add(1, "month")
				.endOf("month")
				.unix();

			this.setFilteredEvents([]);
			this.loadEvents(dates);

			// Add one day, week or month to both dates if it's a range or not.
			this.setCurrentDate({
				date: [dates.start, dates.end],
				span: "month"
			});
		},
		hasEvent: function(day) {
			var currentDate = moment
				.unix(this.data.currentDate[0])
				.date(day)
				.format("YYYYMMDD");
			let events = this.data.events;

			// console.log("events", events);

			return events.some(event => {
				let item = event.node;
				let startDate = moment(item.dates.startDate).format("YYYYMMDD");
				let endDate = item.dates.endDate
					? moment(item.dates.endDate).format("YYYYMMDD")
					: moment(item.dates.startDate).format("YYYYMMDD");

				return startDate <= currentDate && currentDate <= endDate;
			});
		},
		isSelected: function(day) {
			return moment
				.unix(this.data.currentDate[0])
				.date(day)
				.isSame(this.selectedDate, "day");
		},
		selectDay: function(day) {
			if (this.hasEvent(day)) {
				let selectedDate = moment
					.unix(this.data.currentDate[0])
					.date(day)
					.format("YYYYMMDD");

				this.data.selectedDate = selectedDate;

				let filteredEvents = [];
				filteredEvents = this.data.events.filter(
					event =>
						(parseInt(event.node.dates.startDate) <= selectedDate &&
							parseInt(event.node.dates.endDate) >=
								selectedDate) ||
						(parseInt(event.node.dates.startDate) == selectedDate &&
							parseInt(event.node.dates.endDate) == "")
				);

				this.setFilteredEvents(filteredEvents);
			}
		},
		resetEvents: function() {
			this.setFilteredEvents(this.data.events);
		}
	},
	watch: {
		"data.currentDate": {
			handler: function() {
				this.selectedDate = moment
					.unix(this.data.currentDate[0])
					.format("YYYYMMDD");
			},
			deep: true
		}
	},
	mounted: function() {
		this.data.dateContext = moment.unix(this.data.currentDate[0]);
	}
};
</script> 

<template>
	<div class="calendar">
		<div class="calendar__header">
			<i tabindex="0" class="fa fa-fw fa-chevron-left calendar__prev" @click.prevent="subtractMonth"></i>
			<span class="month-year" @click.prevent="resetEvents">{{month + ' ' + year}}</span>
			<i tabindex="0" class="fa fa-fw fa-chevron-right calendar__next" @click.prevent="addMonth"></i>
		</div>
		<ul class="weekdays">
			<li class="day" :key="day + index" v-for="(day, index) in days">{{day}}</li>
		</ul>
		<ul class="dates">
			<li
				class="day day--previous"
				:key="'last' + index"
				v-for="(day, index) in firstDaysOfMonth"
			>{{day}}</li>
			<li
				class="day"
				:key="date"
				v-for="date in daysInMonth"
				:class="{'current-day': date == initialDate && month == initialMonth && year == initialYear, 'has-event' : hasEvent(date), 'selected-day' : (isSelected(date) && hasEvent(date))}"
				@click="selectDay(date)"
			>
				<span class="date">{{date}}</span>
			</li>
			<li class="day day--next" :key="'next' + index" v-for="(day, index) in lastDaysOfMonth">{{day}}</li>
		</ul>
	</div>
</template>


<style lang="scss" scoped>
// Import our variables for use.
@import "../assets/styles/_variables";

// reset <ul> styles
.dates,
.weekdays {
	list-style: none;
	padding-left: 0;
	margin-bottom: 0;
}

.calendar {
	// border: 1px solid #ccc;
	border-right: 1px solid #ccc;
	text-align: center;
}

.calendar__prev,
.calendar__next {
	cursor: pointer;
	border-radius: 100%;
	width: 30px;
	height: 30px;
	line-height: 30px;
	transition: 0.25s ease all;
	color: #4c742f;

	&:hover,
	&:focus {
		// background: $gray-700;
	}
}

.calendar__header {
}

.weekdays {
	// background: $gray-200;

	.day {
		// padding: 5px 0;

		&:before {
			content: "";
		}
	}
}

.dates {
	// background-color: #fcfcfc;
	li {
	}
	.day {
		// border: 1px solid $gray-300;
		// padding: 5px 0;
		border-right: 0;
		// margin-top: -1px;

		&:before {
			content: "";
		}

		span {
			display: block;
			// width: 30px;
			// height: 30px;
			margin: auto;
			// line-height: 30px;
			// border-radius: 100%;
			transition: 0.25s ease all;
		}

		&.has-event {
			font-weight: 700;

			span {
				cursor: pointer;

				&:hover,
				&:focus {
					// background: $gray-300;
				}
			}
		}

		&.selected-day {
			span {
				// background: $gray-300;
				// outline: 3px solid $red;
			}
		}

		&.current-day {
			// background: $gray-200;
		}

		&:nth-of-type(7n + 7),
		&:last-of-type {
			// border-right: 1px solid $gray-300;
		}
	}
}

.weekdays,
.dates {
	display: flex;
	flex-wrap: wrap;
	margin: 0;
	padding: 0;

	// 1/7 * 100%;
	li {
		flex: 0 0 14.28571%;

		// &:before {
		//   content: "";
		// }
	}
}
</style>
